import React, { FC } from 'react';
import {
  CardInfo,
  CardInfoItem,
  CardInfoValueType,
  FlexItem,
  H3,
} from '@erecruit/ui-kit';
import { Intl } from '@erecruit/core';
import { Resources } from '@erecruit/types';
import { currencySymbol } from '../../../AddNewPositionWizard/components/BillingStep/helpers';

const { FormattedMessage, injectIntl } = Intl;

interface BonusSectionProps extends Intl.InjectedIntlProps {
  data: Resources.ShiftBonus;
}

const BonusSection: FC<BonusSectionProps> = props => {
  const { bonusPay, bonusBill } = props.data;
  return (
    <FlexItem>
      <CardInfo
        title={
          <H3 align="center">
            <FormattedMessage id={messageIds.vms.shiftRecord.bonus.title} />
          </H3>
        }
      >
        <CardInfoItem
          label={
            <FormattedMessage id={messageIds.vms.shiftRecord.bonus.bonusPay} />
          }
          type={CardInfoValueType.Text}
          value={bonusPay ? `${currencySymbol(props.intl)}${bonusPay}` : '-'}
        />
        <CardInfoItem
          label={
            <FormattedMessage id={messageIds.vms.shiftRecord.bonus.bonusBill} />
          }
          type={CardInfoValueType.Text}
          value={bonusBill ? `${currencySymbol(props.intl)}${bonusBill}` : '-'}
        />
      </CardInfo>
    </FlexItem>
  );
};

export default injectIntl(BonusSection);
